import { Divider, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import DialogModal from 'components/UI/DialogModal';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FiltersDate from './FiltersDate';

interface Props {
    open: boolean;
    startDate: any;
    endDate: any;
    onClose: () => void;
    onSubmit: () => void;
    onChangeStartDate: (value: any) => void;
    onChangeEndDate: (value: any) => void;
};


const OpenReportModal: React.FC<Props> = ({ open, startDate, endDate, onClose, onSubmit, onChangeStartDate, onChangeEndDate
}) => {
    const { t } = useTranslation();
    return (
        <>
            <DialogModal
                open={open}
                onClose={onClose}
                title={t('T_generate_report')}
                maxWidth="md"
                sx={{
                    "& .MuiDialog-paper": {
                        borderRadius: 3,
                        minHeight: "100%",
                        overflow: "hidden",
                    },
                }}
                children={
                    <>
                        <Grid container spacing={2} sx={{
                            mt: 2,
                        }}>
    
                            <FiltersDate
                                onChangeFrom={onChangeStartDate}
                                onChangeTo={onChangeEndDate}
                                valueFrom={startDate}
                                valueTo={endDate}
                            />
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12}>

                                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                                    <Button
                                        variant="text"
                                        color="primary"
                                        onClick={onClose}
                                        style={{
                                            marginInline: "10px",
                                            fontSize: "16px",
                                            fontWeight: 600,
                                        }}
                                    >
                                        {t("T_close")}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={onSubmit}
                                        style={{
                                            marginInline: "10px",
                                            fontSize: "16px",
                                            fontWeight: 600,
                                        }}
                                    >
                                        {t("T_generate_report")}
                                    </Button>
                                </Stack>
                            </Grid>

                        </Grid>
                    </>
                }
            />
        </>
    );
}

export default OpenReportModal;